import type { IntakeApi } from '../api';
import { REFERRAL_VAR } from './attribution';
import { tripDraft, updateTripDraft } from './session';

/** The landing's referral while the API is asked (null once it has answered, or when there is none). */
let pending: Promise<void> | null = null;

/**
 * The landing's `applyReferral` (referralApply.ts, loaded only for a `?buddy=` link), its
 * answer merged into the trip draft. A chunk that fails to load counts as no answer. Nothing waits for it
 * except the enquiry's creation (`referralSettled`).
 */
export function landReferral(
  api: Pick<IntakeApi, 'resolveReferral'>,
  search: string,
  href: string,
  referrer: string,
) {
  if (!new URLSearchParams(search).get(REFERRAL_VAR)) return;
  const run = import('./referralApply')
    .then((m) => m.applyReferral(api, search, href, referrer))
    .then((changed) => {
      if (changed) updateTripDraft({ attribution: { ...tripDraft.get().attribution, ...changed } });
    })
    .catch(() => undefined)
    .finally(() => {
      if (pending === run) pending = null;
    });
  pending = run;
}

/**
 * Resolves once the landing's referral has answered, or after `maxMs`: the enquiry is created
 * with the Buddy's affiliate id and visit when they arrive in time (a check whose trip is
 * already in the draft creates it straight away), and with the raw `?buddy=` otherwise.
 */
export function referralSettled(maxMs = 3000): Promise<void> {
  const p = pending;
  if (!p) return Promise.resolve();
  return new Promise((resolve) => {
    const timer = setTimeout(resolve, maxMs);
    void p.finally(() => {
      clearTimeout(timer);
      resolve();
    });
  });
}
